import React from "react";
import { Snackbar, Alert, AlertColor } from "@mui/material";
import { useAppSelector, useAppDispatch, removeToast } from "../../store";

const ToastProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const dispatch = useAppDispatch();
  const { toasts } = useAppSelector((state) => state.ui);

  const handleClose = (id: string) => {
    dispatch(removeToast(id));
  };

  return (
    <>
      {children}
      {toasts.map((toast, index) => (
        <Snackbar
          key={toast.id}
          open={true}
          autoHideDuration={toast.autoHideDuration}
          onClose={() => handleClose(toast.id)}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          sx={{
            bottom: { xs: 24 + index * 60, sm: 24 + index * 60 },
          }}
        >
          <Alert
            onClose={() => handleClose(toast.id)}
            severity={toast.severity as AlertColor}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {toast.message}
          </Alert>
        </Snackbar>
      ))}
    </>
  );
};

export default ToastProvider;
